import clsx from 'clsx';
import React, { memo } from 'react';
import BaseLink from './components/BaseLink';

interface ExternalLinkProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  Icon?: React.FC<any>;
  label: string;
  className?: string;
  iconClassName?: string;
}

const ExternalLink = ({ className, iconClassName, Icon, label, ...props }: ExternalLinkProps) => {
  return (
    <BaseLink
      type="external"
      Icon={Icon}
      label={label}
      className={className}
      iconClassName={iconClassName}
      props={{ ...props }}
    />
  );
};

export default memo(ExternalLink);
